import { React } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { Select, FormControl, InputLabel } from '@mui/material';

const UserOrgSelector = ({ setUserOrgName, organizations, fetchUsers, setFilterByOrg, filterByOrg }) => {
  const { t } = useTranslation();
  const allUsers = t('all_users');

  const handleClick = (organization) => {
    fetchUsers(organization?.id);
    setUserOrgName(organization?.name ? organization.name : allUsers);
    setFilterByOrg(organization?.name ? organization.name : allUsers);
  };

  const getOrganizationItems = () => {
    const organizationItems = [
      <MenuItem key={t('filter_organizations')} onClick={handleClick} value={allUsers}>
        {allUsers}
      </MenuItem>,
    ];
    _.forEach(organizations, (organization, organizationID) => {
      organizationItems.push(
        <MenuItem key={organizationID} onClick={() => handleClick(organization)} value={organization.name}>
          {organization.name}
        </MenuItem>
      );
    });
    return organizationItems;
  };

  return (
    <FormControl size={'small'} style={{ minWidth: 150 }}>
      <InputLabel>{t('org')}</InputLabel>
      <Select label={t('org')} value={t(filterByOrg)}>
        {getOrganizationItems()}
      </Select>
    </FormControl>
  );
};
UserOrgSelector.propTypes = {
  setUserOrgName: PropTypes.func.isRequired,
  setFilterByOrg: PropTypes.func.isRequired,
  organizations: PropTypes.array,
  fetchUsers: PropTypes.func.isRequired,
  filterByOrg: PropTypes.string,
};
UserOrgSelector.defaultProps = {
  organizations: [],
  filterByOrg: '',
};
export default UserOrgSelector;
